import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import DescribeDatapointForm from './form'

const DescribeDatapointDialog = React.forwardRef(function DescribeDatapointDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource, datapoint) => setDialogState({
      open: true,
      processing: false,
      dataSource,
      datapoint
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Describe Datapoint'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DescribeDatapointForm
            dataSource={dialogState.dataSource}
            datapoint={dialogState.datapoint}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

DescribeDatapointDialog.propTypes = {
  onComplete: PropTypes.func
}

DescribeDatapointDialog.defaultProps = {
  onComplete: () => {}
}

export default DescribeDatapointDialog
